import { render, staticRenderFns } from "./invites.vue?vue&type=template&id=ca768f58&scoped=true"
import script from "./invites.vue?vue&type=script&lang=js"
export * from "./invites.vue?vue&type=script&lang=js"
import style0 from "./invites.vue?vue&type=style&index=0&id=ca768f58&prod&lang=scss&scoped=true"
import style1 from "./invites.vue?vue&type=style&index=1&id=ca768f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca768f58",
  null
  
)

export default component.exports